module.exports = __webpack_public_path__ + "static/media/big-border.3b75dc04.svg";